/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';
import ChartTest from '../components/ChartTest';

const ChartTestPage = () => {
    return (
        <div className="p-4">
            <h1 className="text-2xl font-bold mb-4">Chart Test Page</h1>
            <ChartTest />
        </div>
    );
};

export default ChartTestPage;
